/**
 * The "My Results" menu — a member's own scores and progress. See
 * lib/navigation/nav-manifest.js for the entry shape and the vocabulary
 * `requires` draws from.
 */

/** @type {import("@/lib/navigation/nav-manifest").NavManifestItem[]} */
export const RESULTS_ITEMS = [
  {
    href: "/dashboard",
    label: "Overview",
    shortcut: "M",
    iconName: "IoHomeOutline",
    requires: "workspace",
  },
  {
    href: "/leaderboard",
    label: "Leaderboard",
    iconName: "CiTrophy",
    requires: "workspace",
  },
  {
    label: "Practice",
    iconName: "LiaTheaterMasksSolid",
    requires: "workspace",
    subItems: [
      {
        href: "/dashboard/discovery",
        label: "Discovery",
        iconName: "CiMap",
        requires: "dashboardModule",
      },
      {
        href: "/dashboard/pitch",
        label: "Messaging / Pitch",
        iconName: "HiOutlinePresentationChartBar",
        requires: "dashboardModule",
      },
      {
        href: "/dashboard/objections",
        label: "Objections",
        iconName: "HiNoSymbol",
        requires: "dashboardModule",
      },
      {
        href: "/dashboard/cold-call",
        label: "Outbound & Inbounds",
        iconName: "IoCallOutline",
        requires: "dashboardModule",
      },
      {
        href: "/dashboard/plays",
        label: "Plays",
        iconName: "LiaTheaterMasksSolid",
        requires: "dashboardModule",
      },
      {
        href: "/dashboard/management",
        label: "Management Practice",
        iconName: "HiOutlineUserGroup",
        requires: "dashboardModule",
      },
    ],
  },
  {
    label: "Execution",
    iconName: "IoFlashOutline",
    requires: "workspace",
    subItems: [
      // These two name what the rep has, not the Execution tool that made
      // it, so a module's title ("Deal Clinic", "Conversation Analyzer")
      // does not replace them (Michael, 20 October).
      {
        href: "/dem-cog/reports",
        label: "Deal Readouts",
        fixedLabel: true,
        iconName: "IoBarChartOutline",
        requires: "dashboardModule",
      },
      {
        href: "/dashboard/transcript-results",
        label: "Conversations",
        fixedLabel: true,
        iconName: "IoStatsChartOutline",
        requires: "dashboardModule",
      },
      {
        href: "/dashboard/plays/on-the-fly",
        label: "On-the-fly Plays",
        iconName: "LiaTheaterMasksSolid",
        requires: "dashboardModule",
      },
    ],
  },
  {
    label: "Progress",
    iconName: "IoStatsChartOutline",
    requires: "workspace",
    subItems: [
      {
        href: "/dashboard/assignments",
        label: "Assignments",
        iconName: "ClipboardList",
      },
      {
        href: "/dashboard/tests",
        label: "Tests",
        iconName: "IoDocumentTextOutline",
      },
      {
        href: "/dashboard/learning-paths",
        label: "Learning Paths",
        iconName: "SlGraduation",
      },
      {
        href: "/dashboard/okrs",
        label: "OKRs",
        iconName: "Target",
        requires: "dashboardModule",
      },
      {
        href: "/dashboard/badges",
        label: "Badges",
        iconName: "IoRibbonOutline",
        requires: "dashboardModule",
      },
    ],
  },
  {
    href: "/dashboard/feedback-analysis",
    label: "Coaching Report",
    iconName: "IoStatsChartOutline",
    requires: "workspace",
  },
  {
    href: "/dashboard/feedback-comments",
    label: "Feedback Comments",
    iconName: "IoChatbubbleOutline",
    requires: "workspace",
  },
  {
    href: "/dashboard/persona-chats",
    label: "Persona Chats",
    iconName: "IoPeopleOutline",
    requires: "workspace",
  },
  {
    href: "/chats",
    label: "Chats",
    iconName: "IoChatbubbleOutline",
    requires: "workspace",
  },
];
